import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { DataExportSchemaConfig } from '../types';
import { DATA_EXPORT_SCHEMA_CONFIG_KEY } from './useDataExportSchemaConfig';

export default function useResetDataExportSchemaConfig() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: () => api.post<DataExportSchemaConfig>('/data-export-config/reset'),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: DATA_EXPORT_SCHEMA_CONFIG_KEY,
      });
    },
  });

  const resetConfig = async () => {
    await mutateAsync();
  };

  return { resetConfig, isLoading };
}
